import React from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ShowSection from './ShowSection';
import GallerySection from './GallerySection';
import TicketSection from './TicketSection';
import Footer from './Footer';

const Homepage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <AboutSection />
      <ShowSection />
      <GallerySection />
      <TicketSection />
      <Footer />
    </div>
  );
};

export default Homepage;